import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { BlockedList } from '../components/BlockReport';
import { Avatar } from '../lib/avatars';
import { supabase } from '../lib/supabase';

export default function Profile({ session }) {
  const navigate = useNavigate();
  const meta = session?.user?.user_metadata || {};
  const [profile, setProfile] = useState({ name: meta.name||'', bio: meta.bio||'', intention: meta.intention||'', visible: meta.visible!==false });
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState('');

  const save = async () => {
    setLoading(true);
    await supabase.auth.updateUser({ data: profile });
    await supabase.from('profiles').update({ name: profile.name, bio: profile.bio, intention: profile.intention, visible: profile.visible }).eq('id', session.user.id);
    setSaved(true); setTimeout(() => setSaved(false), 2000);
    setLoading(false);
  };

  const exportData = async () => {
    const { data: p } = await supabase.from('profiles').select('*').eq('id', session.user.id).single();
    const { data: m } = await supabase.from('messages').select('*').or(`sender_id.eq.${session.user.id},receiver_id.eq.${session.user.id}`);
    const blob = new Blob([JSON.stringify({ profile: p, messages: m||[], exported_at: new Date().toISOString() }, null, 2)], { type:'application/json' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'nearme-data.json'; a.click();
  };

  const deleteAccount = async () => {
    if (deleteConfirm !== 'DELETE') return;
    setLoading(true);
    await supabase.rpc('delete_user_account');
    await supabase.auth.signOut();
    navigate('/');
  };

  const inputStyle = { width:'100%', padding:'12px 15px', background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'11px', color:'white', fontSize:'0.88rem', outline:'none', boxSizing:'border-box' };
  const chip = (active, label, onClick) => <button type="button" onClick={onClick} style={{ padding:'7px 14px', background: active?'white':'rgba(255,255,255,0.04)', border:`1px solid ${active?'white':'rgba(255,255,255,0.07)'}`, borderRadius:'100px', color: active?'#080808':'rgba(255,255,255,0.4)', fontSize:'0.8rem', fontWeight: active?600:400, cursor:'pointer' }}>{label}</button>;

  return (
    <div style={{ background:'#080808', minHeight:'100vh' }}>
      <Navbar session={session}/>
      <div style={{ maxWidth:'460px', margin:'0 auto', padding:'80px 20px 60px' }}>
        <h1 style={{ fontSize:'1.4rem', fontWeight:700, color:'white', marginBottom:'28px', letterSpacing:'-0.5px' }}>My Profile</h1>

        {/* Avatar */}
        <div style={{ textAlign:'center', marginBottom:'24px' }}>
          <Avatar gender={meta.gender} userId={session?.user?.id} size={72} verified={meta.verified}/>
          <div style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.8rem', marginTop:'8px' }}>{session?.user?.email}</div>
          {meta.age && <div style={{ color:'rgba(255,255,255,0.18)', fontSize:'0.75rem', marginTop:'2px' }}>{meta.gender} · {meta.age} years old</div>}
        </div>

        {/* Form */}
        <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:'18px', padding:'22px', display:'flex', flexDirection:'column', gap:'16px', marginBottom:'12px' }}>
          <div>
            <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.68rem', marginBottom:'6px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>First name</label>
            <input value={profile.name} onChange={e => setProfile({...profile, name:e.target.value})} style={inputStyle}/>
          </div>
          <div>
            <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.68rem', marginBottom:'6px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>Bio</label>
            <textarea value={profile.bio} onChange={e => setProfile({...profile, bio:e.target.value})} placeholder="Tell people about yourself..." rows={3} style={{ ...inputStyle, resize:'none', lineHeight:1.6 }}/>
          </div>
          <div>
            <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.68rem', marginBottom:'8px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>I am looking for</label>
            <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
              {['Relationship','Something casual','Friendship','Not sure yet'].map(i => chip(profile.intention===i, i, () => setProfile({...profile, intention:i})))}
            </div>
          </div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'rgba(255,255,255,0.03)', padding:'12px 14px', borderRadius:'10px' }}>
            <div>
              <div style={{ fontWeight:500, fontSize:'0.87rem', color:'white' }}>Visible on map</div>
              <div style={{ color:'rgba(255,255,255,0.22)', fontSize:'0.75rem', marginTop:'1px' }}>{profile.visible?'Others can see you':'You are hidden'}</div>
            </div>
            <div onClick={() => setProfile({...profile, visible:!profile.visible})} style={{ width:'46px', height:'25px', background: profile.visible?'white':'rgba(255,255,255,0.07)', borderRadius:'100px', cursor:'pointer', position:'relative', transition:'background 0.3s' }}>
              <div style={{ position:'absolute', top:'3px', left: profile.visible?'23px':'3px', width:'17px', height:'17px', background: profile.visible?'#080808':'rgba(255,255,255,0.2)', borderRadius:'50%', transition:'left 0.3s' }}/>
            </div>
          </div>
        </div>

        <button onClick={save} disabled={loading} style={{ width:'100%', padding:'13px', background: saved?'rgba(0,214,143,0.12)':'white', color: saved?'#00d68f':'#080808', border: saved?'1px solid rgba(0,214,143,0.25)':'none', borderRadius:'12px', fontSize:'0.88rem', fontWeight:600, cursor:'pointer', marginBottom:'10px' }}>
          {saved?'Saved':loading?'Saving...':'Save changes'}
        </button>

        {/* Blocked users */}
        <BlockedList session={session}/>

        {/* GDPR */}
        <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.05)', borderRadius:'16px', padding:'18px', marginBottom:'10px' }}>
          <div style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.25)', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:'12px' }}>Your data — GDPR</div>
          <div style={{ display:'flex', gap:'8px' }}>
            <button onClick={exportData} style={{ flex:1, padding:'10px', background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'9px', color:'rgba(255,255,255,0.5)', fontSize:'0.8rem', cursor:'pointer' }}>Download my data</button>
            <button onClick={async () => { await supabase.auth.signOut(); navigate('/'); }} style={{ flex:1, padding:'10px', background:'transparent', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'9px', color:'rgba(255,255,255,0.3)', fontSize:'0.8rem', cursor:'pointer' }}>Sign out</button>
          </div>
        </div>

        {/* Danger zone */}
        <div style={{ background:'rgba(255,30,30,0.03)', border:'1px solid rgba(255,30,30,0.1)', borderRadius:'16px', padding:'18px' }}>
          <div style={{ fontSize:'0.72rem', color:'rgba(255,100,100,0.5)', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:'10px' }}>Danger zone</div>
          {!showDelete ? (
            <button onClick={() => setShowDelete(true)} style={{ padding:'9px 16px', background:'transparent', border:'1px solid rgba(255,50,50,0.15)', borderRadius:'9px', color:'rgba(255,100,100,0.6)', fontSize:'0.8rem', cursor:'pointer' }}>Delete my account</button>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:'9px' }}>
              <p style={{ color:'rgba(255,255,255,0.28)', fontSize:'0.8rem', lineHeight:1.6 }}>This permanently deletes everything. Type DELETE to confirm.</p>
              <input value={deleteConfirm} onChange={e => setDeleteConfirm(e.target.value)} placeholder='Type "DELETE"' style={{ ...inputStyle, borderColor:'rgba(255,50,50,0.15)' }}/>
              <div style={{ display:'flex', gap:'7px' }}>
                <button onClick={deleteAccount} disabled={deleteConfirm!=='DELETE'||loading} style={{ flex:1, padding:'10px', background: deleteConfirm==='DELETE'?'rgba(200,30,30,0.8)':'rgba(255,50,50,0.15)', border:'none', borderRadius:'9px', color:'white', fontSize:'0.8rem', fontWeight:600, cursor: deleteConfirm==='DELETE'?'pointer':'not-allowed' }}>Delete permanently</button>
                <button onClick={() => { setShowDelete(false); setDeleteConfirm(''); }} style={{ flex:1, padding:'10px', background:'transparent', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'9px', color:'rgba(255,255,255,0.25)', fontSize:'0.8rem', cursor:'pointer' }}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
